
import { motion } from 'framer-motion';

const AboutHero = () => {
  return (
    <section className="relative h-[70vh] w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/177ae5563a1356f60673eeec607d5e85.jpg"
          alt="About Background"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/50"></div>
      </div>

      <div className="relative h-full flex items-center justify-center px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.3 }}
          className="text-center max-w-4xl"
        >
          <h1 className="font-playfair text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
            ABOUT SUSAN GITELSON
          </h1>
          <p className="font-lora text-xl text-white/90 leading-relaxed">
            A literary voice dedicated to exploring the depths of human experience through compelling narratives and authentic storytelling
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default AboutHero;
